import { RefObject, useEffect, useRef } from "react"
import L from "leaflet"
import "leaflet.markercluster"
import { IRailwayStation } from "../../shared-interfaces/railway-station"

const markerCss = "leaflet-marker station"
const markerSize = 30

const iconCreateFunction = (cluster: any) => {
  // @ts-ignore
  return new L.DivIcon(L.extend({
    className: markerCss,
    html: `
      <div></div>
      ​<span>${cluster.getChildCount()}</span>
    `,
  }, { iconSize: [markerSize, markerSize] }))
}

const template = `
  <div class="station-map-widget">
    <div class="container">
      <h5 class="station-name">{name}</h5>
      <div class="station-info-table">
        <div class="station-title-column">
          <div>Kilometerstein</div>
          <div>Entfernung</div>
        </div>   
        <div class="station-value-column">
          <div>{routeMilestone} km</div>
          <div>ca. {minDistanceToRoute} km</div>
        </div>      
      </div>
  
      <div class="station-link-table">
        <div class="station-from-here-link-column">
          <a target="_blank" href="https://reiseauskunft.bahn.de/bin/query.exe/dn?protocol=https:&from={name}">als Start</a>
        </div>   
        <div class="station-to-here-link-column">
          <a target="_blank" href="https://reiseauskunft.bahn.de/bin/query.exe/dn?protocol=https:&to={name}">als Ziel</a>
        </div>      
      </div>
      <div class="hint">für die Bahnreise verwenden</div>
    </div>
  </div>
`

export const useRailwayStationsEffect = (stations: IRailwayStation[] | null, mapVisible: boolean, map: RefObject<L.Map | null>) => {

  const markers = useRef<any>(null)

  useEffect(() => {

    if (markers.current && map.current) {
      map.current.removeLayer(markers.current)
    }

    if (mapVisible && stations) {

      markers.current = L.markerClusterGroup({
        maxClusterRadius: 50,
        showCoverageOnHover: false,
        spiderLegPolylineOptions: { weight: 0 }, // makes the spider legs unvisible
        // @ts-ignore
        elementsPlacementStrategy: "spiral",
        spiderfyDistanceMultiplier: 1.6,
        iconCreateFunction,
      })

      // @ts-ignore
      const icon = L.divIcon(L.extend({
        html: `<div></div>`,
        className: markerCss,
        iconSize: [markerSize, markerSize],
      }))

      stations.forEach(station => {

        const marker = L.marker([station.lat, station.lng], {
          // @ts-ignore
          station,
          icon,
        })

        marker.bindPopup((currentMarker: any) => {
          const currentStation = currentMarker.options.station

          return L.Util.template(template, {
            name: currentStation.name,
            routeMilestone: Math.round(currentStation.routeMilestone),
            minDistanceToRoute: Math.ceil(currentStation.minDistanceToRoute),
          })

        }, {
          className: "leaflet-popup-yovelino station",
          maxWidth: 190,
          minWidth: 190,
        }).openPopup()

        markers.current.addLayer(marker)
      })

      map.current!.addLayer(markers.current)
    }
  }, [stations, mapVisible, map])
}
